import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import WebsitePageLayoutComponent from './website-page-layout.component';
import AddWebsitePageComponent from './website-page-create.component';



export const WebsitesPageComponent = ({handleFormChange,networks,setPageData,paginationData,additionButtons,onEdit,columnDefs, id,selectedPages,handleInnerFormChange,layout,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Website Page Information',
        component:<AddWebsitePageComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedPages={selectedPages}
        networks={networks}
        handleFormChange={handleFormChange}
        />,
        isVisible:id == 0? true : false
    },
    {
        id:2,
        title:'Website Page Layout Information',
        component:<WebsitePageLayoutComponent 
        rowData={layout}
        columnDefs={columnDefs}
        onEdit={onEdit}
        additionButtons={additionButtons}
        paginationData={paginationData}
        setPageData={setPageData}
        />,
        isVisible: id > 0 ? true : false,
    },
    
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
      {id == 0 && <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>}
             {id == 0 &&  <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>}
        </div>
       </div>
  )
}
export default WebsitesPageComponent;
